"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SDK(baseUrl, fetch) {
  function _fetchJson(url) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, res, _res, data, text;

      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};

      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'content-type', 'application/json'));
      } // some of the sdks are used in the browswer where the native fetch is used.


      if (typeof window === 'undefined') {
        options.responseType = 'json';
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_4) {
          try {
            res = $await_4;
            return $return(res.body);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } else {
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_5) {
          try {
            _res = $await_5;

            if (_res.ok) {
              return Promise.resolve(_res.json()).then($return, $error);
            } else {
              if (_res.headers.get('Content-Type').indexOf('application/json') !== -1) {
                return Promise.resolve(_res.json()).then(function ($await_7) {
                  try {
                    data = $await_7;
                    return $error(_objectSpread({
                      status: _res.status
                    }, data));
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }, $error);
              }

              return Promise.resolve(_res.text()).then(function ($await_8) {
                try {
                  text = $await_8;
                  return $error(text);
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            }

            return $If_1.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }

      function $If_1() {
        return $return();
      }

      return $If_1.call(this);
    });
  }

  return {
    getBudgets: function getBudgets(count) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/budgets".concat(count ? "?count=".concat(count) : ''))).then($return, $error);
      });
    },
    getBudgetsForPerson: function getBudgetsForPerson() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var includeInactiveBudgets, body, includeInactive;
        includeInactiveBudgets = $args.length > 0 && $args[0] !== undefined ? $args[0] : false;
        body = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
        includeInactive = includeInactiveBudgets === true ? 'true' : 'false';
        return Promise.resolve(_fetchJson("/budgets/person?includeInactiveBudgets=".concat(includeInactive), {
          method: 'POST',
          body: JSON.stringify(body)
        })).then($return, $error);
      });
    },
    validate: function validate(_ref) {
      return new Promise(function ($return, $error) {
        var budgets, withHold, caller;
        budgets = _ref.budgets, withHold = _ref.withHold, caller = _ref.caller;
        return Promise.resolve(_fetchJson('/budgets/validate', {
          method: 'PUT',
          body: JSON.stringify({
            caller: caller,
            budgets: budgets,
            withHold: withHold
          })
        })).then($return, $error);
      });
    },
    issue: function issue(validationIds) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/budgets/issue', {
          method: 'PUT',
          body: JSON.stringify({
            validationIds: validationIds
          })
        })).then($return, $error);
      });
    }
  };
}

module.exports = function (url, customFetch) {
  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }

  return new SDK(url, customFetch);
};
//# sourceMappingURL=index.js.map